import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex-column-box new-video-left-wrap" }
const _hoisted_2 = { class: "upload-btn-wrap" }
const _hoisted_3 = { class: "flex-row-box select-btn-radio" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "music-list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "music-info" }
const _hoisted_9 = { class: "music-name" }
const _hoisted_10 = { class: "music-time" }
const _hoisted_11 = { class: "opt-btn-wrap" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]

import { ref, watch } from 'vue';
import {Search} from '@element-plus/icons-vue';
import {materialMusics} from '../bg.js';


export default /*@__PURE__*/_defineComponent({
  __name: 'music',
  props: {
  clearFlag: {
    type: Number,
    default: 0
  }
},
  setup(__props) {

const props = __props
const keywords = ref('');

const types = ref([
  {
    label: '收藏',
    value: '1'
  }, {
    label: '全部',
    value: '2'
  }
]);
const activeType = ref('1');
const toggleType = (type) => {
  activeType.value = type;
}

const musics = ref(materialMusics);
// const showMusicLists = computed(() => {
//   if(activeType.value == '1') return musics.value.filter(item => item.status=='1');
//   return musics;
// })

const activeId = ref(1);
const toggleData = (d) => {
  activeId.value = d.material_id;
}

const likeMusic = (m) => {
  if (m.start=='1') m.start='0'
  else m.start = '1';
}

const addMusic = (m) => {
  console.log(m);
}

watch(()=>props.clearFlag, (newVal)=>{
  if(newVal) {
    
  }
})

// const getMusics = () => {
//   musics.value = materialMusics
// }

// onMounted({
//   getMusics();
// })

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_StarFilled = _resolveComponent("StarFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Plus = _resolveComponent("Plus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        modelValue: keywords.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keywords).value = $event)),
        placeholder: "搜索音乐",
        "prefix-icon": _unref(Search),
        size: "large"
      }, null, 8, ["modelValue", "prefix-icon"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(types.value, (item) => {
        return (_openBlock(), _createElementBlock("a", {
          key: item.value,
          class: _normalizeClass(item.value == activeType.value && 'active'),
          onClick: ($event: any) => (toggleType(item.value))
        }, _toDisplayString(item.label), 11, _hoisted_4))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(musics.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "music-item",
          key: item.material_id,
          onClick: ($event: any) => (toggleData(item))
        }, [
          _createElementVNode("img", {
            src: item.asset_details.album_pic,
            alt: "",
            style: {"min-width":"2.5vw","width":"2.5vw","height":"2.5vw","border-radius":"0.208vw","overflow":"hidden"}
          }, null, 8, _hoisted_7),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(item.asset_details.album_name), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(item.asset_details.duration), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("a", {
              onClick: ($event: any) => (likeMusic(item))
            }, [
              _createVNode(_component_el_icon, {
                color: item.start=='1'?'rgba(87, 84, 249, 1)':'#fff'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_StarFilled)
                ]),
                _: 2
              }, 1032, ["color"])
            ], 8, _hoisted_12),
            _createElementVNode("a", {
              onClick: ($event: any) => (addMusic(item))
            }, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Plus)
                ]),
                _: 1
              })
            ], 8, _hoisted_13)
          ])
        ], 8, _hoisted_6))
      }), 128))
    ])
  ]))
}
}

})